{
  "columns": {
    "lca": {
      "completionIndex": "Accuracy",
      "dateCreated": "Last update",
      "ecs": "Environmental cost",
      "name": "Name",
      "pef": "PEF score (µPt PEF)",
      "reference": "Reference",
      "status": "Status",
      "webUrl": "LCA details"
    },
    "rdue": {
      "brandReference": "Reference",
      "compliant": "Compliant",
      "component": {
        "material": {
          "country": "Country",
          "name": "Material",
          "scientificName": "Scientific Name"
        }
      },
      "component_certificates": "Component {{index}} Certificates",
      "component_details": "Component {{index}} Details",
      "composition": "Composition",
      "compositionCount_one": "{{count}} material",
      "compositionCount_other": "{{count}} materials",
      "documents": "Documents",
      "dueDiligence": "Due Diligence Statement",
      "hsCode": "Harmonized System Code",
      "name": "Name",
      "purchaseOrder": "Purchase Order (PO)",
      "quantity": "Quantity per PO",
      "relevantCommodity": "Relevant Commodity"
    }
  },
  "lists": {
    "labels": {
      "dueDiligence": "Generate Due Diligence",
      "dueDiligence_one": "Generate due diligence statement for {{count}} product",
      "dueDiligence_other": "Generate due diligence statement for {{count}} products",
      "selectCompliant": "Select Compliant"
    },
    "placeholders": {
      "agec": "Compliance",
      "no": "no",
      "rdueStatus": "EUDR status",
      "search": "Search...",
      "yes": "yes"
    },
    "tabs": {
      "agec": "AGEC",
      "lca": "Environmental labeling",
      "rdue": "EUDR"
    },
    "title": "Regulations"
  },
  "notSubscribed": {
    "message": "You are not subscribed to this feature. Please contact your account manager.",
    "title": "Feature not subscribed"
  },
  "runLcaOnProducts_one": "Run LCA on {{count}} product",
  "runLcaOnProducts_other": "Run LCA on {{count}} products",
  "values": {
    "lca": {
      "error": "Product ineligible for LCA",
      "errors": {
        "default": "An unexpected error occured. Please try again later, or contact the support team.",
        "missingData": "Missing product information: {{args}}",
        "unaccessible": "The third-party service is currently unavailable. Please try again later.",
        "unsupportedData": "Data not supported by Ecobalyse: {{args}}."
      },
      "pending": "No LCA available",
      "success": "LCA successfully run"
    },
    "status": {
      "error_one": "Unable to update ({{count}} day ago)",
      "error_other": "Unable to update ({{count}} days ago)",
      "success_one": "Updated ({{count}} day ago)",
      "success_other": "Updated ({{count}} days ago)"
    }
  }
}
